import { useEffect, useState } from 'react'

type Props = {
  children: (innerWidth: number) => void
}

const InnerWidth = ({ children }: Props) => {
  const [innerWidth, setInnerWidth] = useState(window.innerWidth)

  useEffect(() => {
    window.addEventListener('resize', (event) =>
      setInnerWidth(window.innerWidth)
    )

    return () => {
      window.removeEventListener('resize', () => {})
    }
  }, [])

  return <>{children(innerWidth)}</>
}

export default InnerWidth
